import React from "react";

const EmptyButton = ({ name, change, targetInput, value, right = 5 }) => {
  const emptyVal = () => {
    targetInput.current.focus();
    change({
      target: {
        name: name,
        value: "",
      },
    });
  };

  var hasValue = value && value !== "";

  return (
    <div
      className={`btn text-default border-0 h-100 noeffect animated ${
        hasValue ? "fadeIn" : "fadeOut"
      }`}
      style={{
        position: "absolute",
        right: right,
        top: 0,
        width: 30,
        padding: "0 5px",
        minHeight: 0,
        borderRadius: "50%",
        zIndex: "9",
        display: "flex",
        placeItems: "center",
      }}
      onClick={emptyVal}
    >
      <i className="fa fa-times" />
    </div>
  );
};

export default EmptyButton;
